import React, { useState } from "react";
import logo from "../images/logo.svg";
import pianoAudio from "../audio/piano.mp3";
import { Link } from "react-router-dom";

const Nav = () => {
  const [play, setPlay] = useState(true);
  const [audio] = useState(new Audio(pianoAudio));
  const toggleAudio = () => {
    audio.loop = true;
    play ? audio.play() : audio.pause();
    setPlay(!play);
  };
  const hideNav = () => {
    window.scrollTo(0, 0);
    document.getElementById("navbar-toggler-btn").classList.add("collapsed");
    document.getElementById("navbarSupportedContent").classList.remove("show");
  };

  return (
    <nav className="navbar navbar-expand-lg fixed-top">
      <div className="container">
        <Link className="navbar-brand" to="/" onClick={hideNav}>
          <img src={logo} alt="logo" className="logo" />
        </Link>
        <button
          className="navbar-toggler"
          id="navbar-toggler-btn"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav mx-auto mb-2 mb-lg-0">
            <li className="nav-item">
              <Link onClick={hideNav} className="nav-link" to="/">
                Home
              </Link>
            </li>
            <li className="nav-item">
              <Link onClick={hideNav} className="nav-link" to="/about">
                About
              </Link>
            </li>
            <li className="nav-item">
              <Link onClick={hideNav} className="nav-link" to="/events">
                Events
              </Link>
            </li>
            <li className="nav-item dropdown">
              <a
                className="nav-link dropdown-toggle"
                href="/"
                id="navbarDropdown"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Learn Piano
              </a>
              <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                <li>
                  <Link
                    onClick={hideNav}
                    className="dropdown-item"
                    to="/piano-lessons"
                  >
                    Piano Lessons
                  </Link>
                </li>
                <li>
                  <Link
                    onClick={hideNav}
                    className="dropdown-item"
                    to="/piano-camp"
                  >
                    Piano Camp
                  </Link>
                </li>
                <li>
                  <Link
                    onClick={hideNav}
                    className="dropdown-item"
                    to="/piano-camp-signup"
                  >
                    Piano Camp Signup
                  </Link>
                </li>
                <li>
                  <Link
                    onClick={hideNav}
                    className="dropdown-item"
                    to="/gallery"
                  >
                    Gallery
                  </Link>
                </li>
              </ul>
            </li>
            <li className="nav-item">
              <Link onClick={hideNav} className="nav-link" to="/contact">
                Contact
              </Link>
            </li>
          </ul>
          <div className="d-flex justify-buttons">
            {play ? (
              <button onClick={toggleAudio} className="volume-btn">
                <i className="fa fa-volume-up"></i>
              </button>
            ) : (
              <button onClick={toggleAudio} className="volume-btn2">
                <i className="fa fa-volume-down"></i>
              </button>
            )}

            <a
              className="shop-btn"
              href="/"
              target="_blank"
              rel="noreferrer"
              onClick={hideNav}
            >
              <i className="fa fa-shopping-cart"></i>
              &nbsp;&nbsp;&nbsp;Shop
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Nav;
